import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import { useEffect, useMemo, useState } from "react";
import { checkAndRemoveInvalid, checkRequiredAndInvalid, makeRequireColumns } from "js/requireCheck";
import BasicButton from "components/button/BasicButton";
import { sendGet } from "api/restUtil";
import Float from "components/input/Float";
import ReactDataTableModifiable from "components/DataTable/ReactDataTableModifiable";

/**
 * 지점 권역 관리 팝업
 */
function BranchAreaMgmtModal (props) {

	const { isOpen, onClose, initData, returnData, modalId, title } = props;
	const [ data, setData ] = useState({})
	const [ mode, setMode ] = useState("add");
	const [ coordData, setCoordData ] = useState([]);
	const [ coordAddRow, setCoordAddRow ] = useState(null);
	const [ coordDelRow, setCoordDelRow ] = useState(null);
	const [ selectRows, setSelectRows ] = useState([]);
    const [dataSend, setDataSend] = useState([]);	// 테이블에서 데이터 변경 시 변경 데이터


	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		// { header : "지점ID", col : "branchId", cellWidth: "100"},
		// { header : "권역번호", col : "branchAreaNo", cellWidth: "100"},
		{ header : "순서", col : "ordr", cellWidth: "100"},
		{ header : "위도", col : "latitude", cellWidth: "100", type: "decimal", addComma: false, decimalPlaceCnt: 12, mod: true, require: true},
		{ header : "경도", col : "longitude", cellWidth : "100", type: "decimal", addComma: false, decimalPlaceCnt: 12, mod: true, require: true },
	], []);
	
	// 데이터 변경 시 invalid 제거 처리
	useEffect(() => {
		checkAndRemoveInvalid(data, "#branchAreaMgmtModal");
	}, [data]);
	useEffect(() => {
		checkAndRemoveInvalid(dataSend, "#branchAreaVert");
	}, [dataSend]);

	const handleDataChange = (e) => {
		const {name, value} = e.target;
		let d = {...data};
		d[name] = value;

		setData(d);
	}

	useEffect(() => {
		if(!isOpen) {
			setCoordData([]);
			return;
		};

		setCoordAddRow(null);	// 이거 초기화 안해주면 닫았다가 다시 열면 행이 남아있음...
		if(initData.hasOwnProperty("branchAreaNo") && initData.branchAreaNo != null && initData.branchAreaNo !== '') {
			setMode("mod");
			searchBranchAreaDetail(initData);
		} else {
			setMode("add");
			setData(initData);
		}
	}, [isOpen]);

	const searchBranchAreaDetail = async(param) => {
		let result = await sendGet("/api/mgmt/branch/" + param.branchId + "/areas/" + param.branchAreaNo);
		if(result.respCode === "SUCCESS") {
			result.data.branchId = param.branchId;
			setData(result.data);

			if(result.data?.polygon?.coordinates) {
				const coordArr = result.data.polygon.coordinates[0];
				const a = [];
				coordArr.forEach((coord, idx) => {
					const coordObj = {"latitude" : coord[1], "longitude" : coord[0], "ordr" : idx+1};
					a.push(coordObj);
				});
				setCoordData(a);
			}
		}
	}

	// 권역 번호 중복 체크
	const checkBranchAreaNoDup = async(branchAreaNo) => {
		if(branchAreaNo === "") return;
		const result = await sendGet("/api/mgmt/branch/dupCheck/" + data.branchId + "/areas/" + branchAreaNo);
		if(result.respCode === "SUCCESS") {
			if(result.data === "Y") {
				alert("사용 가능한 권역 번호 입니다.");
			} else {
				alert("사용이 불가한 권역 번호 입니다.");
			}
		}
	}

	// 순서 변경
	const resetOrdr = (changedData) => {
		changedData.forEach((d, idx) => {
			d.ordr = idx + 1;
		});
		setCoordData(changedData);
	}

	//행 추가 버튼
	const onAddRow=()=> {

		const newRow = {};
		const ordrArr = dataSend.map(d => d.ordr);
		const maxOrdr = ordrArr.length == 0 ? 1 : Math.max(...ordrArr) + 1;
		newRow.ordr = maxOrdr;
		setCoordAddRow(newRow);
	}

	// 행 삭제 버튼
	const onDelRow = () => {
		setCoordDelRow(selectRows.map(r => ({ordr: r.ordr})));
	}

	const onClickOk = () => {

		// 저장을 위한 형태로 변경
		const saveData = {};
		saveData.branchId = data.branchId;
		saveData.branchAreaNo = data.branchAreaNo;
		saveData.activationYn = data.activationYn == null ? true : data.activationYn;
		saveData.deliveryAgencyCode = "DAC";

		const coord = dataSend.map(d => [d.longitude * 1, d.latitude * 1]);
		// coord.push(coord[0]);	// 끝점이 일치하도록 처음 값을 마지막에 한번 더 넣기
		
		const polygon = {};
		polygon.coordinates = [coord];

		saveData.polygon = polygon;

		
		// 필수 체크 - brancAreaNo,  coord.length (최소 4개), 마지막 값은 첫번째 값과 일치 해야 함.
		if(mode === "add") {
			const requiredColumns = ["branchAreaNo"];
			if(!checkRequiredAndInvalid(makeRequireColumns(requiredColumns), data, "#branchAreaMgmtModal")) return;
		}

		if(!checkRequiredAndInvalid(columns, dataSend, "#branchAreaVert")) return;


		const coordErrMsg = "좌표는 최소 4개가 등록되어야 하며, 처음과 끝의 좌표는 동일해야 합니다.";
		if(coord.length < 4) {
			alert(coordErrMsg);
			return;
		}

		const firstCoord = coord[0];
		const lastCoord = coord[coord.length-1];
		if(firstCoord[0] !== lastCoord[0] || firstCoord[1] !== lastCoord[1]) {
			alert(coordErrMsg);
			return;
		}

		returnData(saveData);
	}


	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={title + "팝업"}
			id={modalId}
		>
			<div className="me-modal">

				<div className="me-modal-container" style={{width: "600px", height: "500px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">{title}</h4>
						</div>

						<div className="me-modal-body" style={{overflowY: "scroll"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="body-area modal-form" id="branchAreaMgmtModal">
								<table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
										{/* <col width="100"/>
										<col width="200"/> */}
									</colgroup>
									<tbody>
										<tr>
											<th>지점 ID</th>
											<td>
												{data.branchId}
											</td>
										</tr>
										<tr>
											<th>지점 명</th>
											<td>
												{initData.branchName}
											</td>
										</tr>
										{mode == "add" && (
											<tr>
												<th>권역 번호<span className="burgundy">*</span></th>
												<td>
													<Float className="basic-input" name={"branchAreaNo"} value={data?.branchAreaNo ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "200px", textAlign: "left", display: "inline-block"}} addComma={false} minVal={1} />
													<BasicButton label="중복확인" onClick={()=>checkBranchAreaNoDup(data?.branchAreaNo)} disabled={!data?.branchAreaNo} className="small-button" style={{marginLeft: "10px"}} />
												</td>
											</tr>
										)}
										{mode == "mod" && (
											<tr>
												<th>권역 번호</th>
												<td>
													{data.branchAreaNo}
												</td>
											</tr>
										)}
										<tr>
											<th>권역 활성화 여부<span className="burgundy">*</span></th>
											<td>
												<select name={"activationYn"} className="basic-input" style={{width: "100px"}} onChange={handleDataChange} value={data?.activationYn}>
													<option value={true}>활성</option>
													<option value={false}>비활성</option>
												</select>
											</td>
										</tr>
									</tbody>
								</table>

								<div className="table-buttons mg-t-5 mg-b-5">
									<BasicButton
										label="행추가"
										className="btn-add"
										onClick={onAddRow}
									/>
									<BasicButton
										label="행삭제"
										className="btn-del"
										disabled={selectRows.length === 0}
										onClick={onDelRow}
									/>
								</div>
								<ReactDataTableModifiable
									dataTableId="branchAreaVert"
									columns={columns}
									customDatas={coordData}
									addRow={coordAddRow}
									delRow={coordDelRow}
									delRowComplete={resetOrdr}
									hideCheckBox={false}
									returnSelectRows={(selects) => setSelectRows(selects)}
									dataSend={setDataSend}
									percentageWidth={true}
									maxHeight="250px"
									rowDraggable={true}
									onRowDragDrop={resetOrdr}
								/>
							</div>

						</div>

						<div className="me-modal-footer mg-t-10 mg-b-20">
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="취소" className="btn-cancel" onClick={onClose} style={{width: "100%"}} />
								<BasicButton label="저장" className="btn-save" onClick={onClickOk} style={{width: "100%"}} />

							</div>
						</div>

					</div>

				</div>
			</div>

		</ReactModal>
	);
}

export default BranchAreaMgmtModal;
